export const faqItems = [
  {
    question: '如何快速提升自己的性感气质？',
    answer: '提升性感气质最快的方法是改善体态。挺直脊椎、放松肩膀、微微抬起下巴——这三个简单的调整能让你的整体气质立刻提升50%。配合自信的眼神交流和自然的微笑，性感气质就会由内而外地散发出来。此外，找到适合自己的香水也是快速提升魅力感的捷径。',
  },
  {
    question: '性感穿搭一定要穿得很暴露吗？',
    answer: '绝对不是。真正的性感来自于"留白"的艺术——恰到好处地展现你最自信的身体部位，而不是大面积裸露。例如，你可以选择露肩设计展现优美的肩颈线条，或者高开衩裙若隐若现地露出腿部。性感的精髓在于激发想象，而不是一览无余。',
  },
  {
    question: '日常上班可以穿得性感吗？',
    answer: '当然可以，关键是要掌握职场性感的度。选择剪裁合身的西装外套、质地精良的丝质衬衫、过膝的铅笔裙等单品，通过面料质感和修身剪裁来展现女性魅力，而不是通过过度暴露。搭配一双尖头高跟鞋和简约的金属配饰，就能打造出专业而不失女人味的职场造型。',
  },
  {
    question: '如何选择适合自己的性感妆容？',
    answer: '选择妆容风格要综合考虑你的脸型、肤色和个人气质。一般来说，圆脸适合拉长眼型的妆容，方脸适合柔化线条的妆容。初学者可以从"眼妆+唇妆二选一"的法则开始——如果你化了烟熏眼妆，唇色就选择裸色系；如果你想涂红唇，眼妆就保持简约干净。',
  },
  {
    question: '气质可以后天培养吗？需要多长时间？',
    answer: '气质完全可以后天培养。从改善体态开始，大约需要21天养成一个新的习惯。同时多读书、多看艺术展、学习一门新技能，丰富自己的内在世界，气质会随着你的阅历和自信自然提升。建议每天花15分钟进行体态训练，坚持2-3个月就会看到明显的变化。',
  },
  {
    question: '没有超模身材，也可以穿出性感风格吗？',
    answer: '当然可以！性感与身材尺寸无关，而与比例和自信有关。了解自己的身材类型（梨形、苹果形、沙漏形、矩形），学会用服装来突出优势、修饰不足，任何身材都能穿出属于自己的性感风格。记住，自信的笑容和挺拔的姿态，比任何身材数据都有魅力。',
  },
];